import {createSlice} from '@reduxjs/toolkit';
const initialState = {
  category: {},
  sidebar: true,
  editInspection: {},
  activeInspection: {},
};

const inspectionSlice = createSlice({
  name: 'inspection',
  initialState,
  reducers: {
    initCategories(state, action) {
      state.category = action.payload;
    },
    setSidebar(state, action) {
      state.sidebar = action.payload;
    },
    setEditInspection(state, action) {
      state.editInspection = action.payload;
    },
    setActiveInspection(state, action) {
      state.activeInspection = action.payload;
    },
    addParentField(state, action) {
      if (state.category.fields.length === 0) {
        state.category.fields = [
          {id: Math.floor(Math.random() * Date.now()) + '', label: null},
        ];
      }
      if (action.payload?.new_form) {
        state.category.fields = [
          ...state.category.fields,
          {id: Math.floor(Math.random() * Date.now()) + '', label: null},
        ];
      }
    },
    changeParentField(state, action) {
      state.category.fields?.map((elem, index) => {
        if (index === action.payload.index) {
          state.category.fields[action.payload.index] = {};
          state.category.fields[action.payload.index] =
            action.payload.field_data;
        }
        return elem;
      });
    },
    removeField(state, action) {
      state.category.fields = state.category.fields?.filter(
        (_, i) => i !== action.payload,
      );
    },
  },
});

export const {
  setActiveInspection,
  setEditInspection,
  addParentField,
  changeParentField,
  initCategories,
  removeField,
  setSidebar,
} = inspectionSlice.actions;
export default inspectionSlice.reducer;
